// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"293":"4fd60a72","432":"af4f97c5","510":"4fd60a72"}[chunkId] + ".chunk.css";
};